import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorProps {
  error?: any;
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  const { t } = useTranslation();
  const base = "contact.form.error.";

  if (!error) return null;

  const errorMessages: Record<string, string> = {
    required: base + "empty",
    patternPhone: base + "phone",
    patternLinkedin: base + "linkedin",
    Mail: base + "mail",
    minLengthPhone: base + "minLengthPhone",
    minLengthName: base + "minLengthName",
    minLengthSurname: base + "minLengthName",
    minLengthDescription: base + "minLengthDescription",
    fileSizeMax: base + "fileSizeMax",
    registeredEmail: "newsletter.join.fetchData.succesEmail",
    existingEmail: "newsletter.join.fetchData.emailInUse",
  };

  const key = error?.message || error?.type;

  return (
    <div className="error-message">
      {errorMessages[key] ? t(errorMessages[key]) : key}
    </div>
  );
};

export default Error;
